module.exports = __webpack_public_path__ + "img/credit-card.c72183cb.svg";